import React, { useState } from "react";
import { postCaja as addCaja } from "../helpers/rutaCajas";
import "../css/addclienteform.css";
import { Modal } from "react-bootstrap";
import "animate.css";

const AddCajaForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const [formValues, setFormValues] = useState({
    // codcaj lo genera el back
    fecha: "",
    descripcion: "",
    montoInicial: "",
    tipo: "CAJA",      // CAJA | BANCO
    // Bancario (solo si tipo === "BANCO")
    banco: "",
    alias: "",
    cbu: "",
    numero: "",
    moneda: "ARS",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => {
      const next = { ...prev, [name]: value };

      // Si cambian a CAJA, limpiamos los datos bancarios
      if (name === "tipo" && value === "CAJA") {
        next.banco = "";
        next.alias = "";
        next.cbu = "";
        next.numero = "";
        next.moneda = "ARS";
      }
      return next;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const monto = Number(formValues.montoInicial ?? 0);
    if (Number.isNaN(monto) || monto < 0) {
      alert("El monto inicial debe ser un número válido mayor o igual a 0.");
      return;
    }

    const tipo = String(formValues.tipo || "CAJA").toUpperCase().trim();

    const payload = {
      fecha: formValues.fecha || undefined,
      descripcion: (formValues.descripcion || "").trim(),
      tipo,
      montoInicial: monto,
      saldoActual: monto, // arranca igual al inicial
      ...(tipo === "BANCO"
        ? {
            banco: (formValues.banco || "").trim(),
            alias: (formValues.alias || "").trim(),
            cbu: (formValues.cbu || "").trim(),
            numero: (formValues.numero || "").trim(),
            moneda: formValues.moneda || "ARS",
          }
        : {}),
    };

    try {
      const resp = await addCaja(payload);
      console.log("✅ Caja/Fondo creado:", resp);

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setFormValues({
          fecha: "",
          descripcion: "",
          montoInicial: "",
          tipo: "CAJA",
          banco: "",
          alias: "",
          cbu: "",
          numero: "",
          moneda: "ARS",
        });
        // Si querés cerrar el modal padre:
        // setShow?.(false);
      }, 1500);
    } catch (error) {
      console.error("❌ Error al crear caja/fondo:", error);
      alert(error?.response?.data?.message || "Error al crear la caja/fondo");
    }
  };

  const esBanco = formValues.tipo === "BANCO";

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group mt-3 col-sm-2">
              <label>Fecha Caja/Fondo</label>
              <input
                type="datetime-local"
                className="form-control"
                name="fecha"
                required
                value={formValues.fecha}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Tipo</label>
              <select
                className="form-control"
                name="tipo"
                value={formValues.tipo}
                onChange={handleChange}
                required
              >
                <option value="CAJA">CAJA (efectivo)</option>
                <option value="BANCO">BANCO (transferencias)</option>
              </select>
            </div>

            <div className="form-group mt-3 col-sm-4">
              <label>Descripción</label>
              <input
                type="text"
                className="form-control"
                name="descripcion"
                required
                maxLength="50"
                value={formValues.descripcion}
                onChange={handleChange}
                placeholder={esBanco ? "Ej: Banco Nación" : "Ej: Caja Principal"}
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Monto Inicial</label>
              <input
                type="number"
                className="form-control"
                name="montoInicial"
                required
                value={formValues.montoInicial}
                onChange={handleChange}
              />
              <small className="form-text text-muted">
                {new Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                }).format(Number(formValues.montoInicial || 0))}
              </small>
            </div>
          </div>

          {esBanco && (
            <>
              <div className="form-row">
                <div className="form-group mt-3 col-sm-3">
                  <label>Banco</label>
                  <input
                    type="text"
                    className="form-control"
                    name="banco"
                    value={formValues.banco}
                    onChange={handleChange}
                    placeholder="Ej: Banco Nación"
                  />
                </div>
                <div className="form-group mt-3 col-sm-3">
                  <label>Alias</label>
                  <input
                    type="text"
                    className="form-control"
                    name="alias"
                    value={formValues.alias}
                    onChange={handleChange}
                    placeholder="ALIAS.CBU"
                    pattern="[A-Za-z0-9\.]{6,30}"
                    title="Alias alfanumérico (6-30) con puntos"
                  />
                </div>
                <div className="form-group mt-3 col-sm-3">
                  <label>CBU</label>
                  <input
                    type="text"
                    className="form-control"
                    name="cbu"
                    value={formValues.cbu}
                    onChange={handleChange}
                    placeholder="22 dígitos"
                    pattern="\d{22}"
                    title="CBU de 22 dígitos"
                  />
                </div>
                <div className="form-group mt-3 col-sm-3">
                  <label>Número de cuenta</label>
                  <input
                    type="text"
                    className="form-control"
                    name="numero"
                    value={formValues.numero}
                    onChange={handleChange}
                    placeholder="Opcional"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group mt-3 col-sm-3">
                  <label>Moneda</label>
                  <select
                    className="form-control"
                    name="moneda"
                    value={formValues.moneda}
                    onChange={handleChange}
                  >
                    <option value="ARS">ARS</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                  </select>
                </div>
              </div>
            </>
          )}

          <div>
            <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">
              Guardar
            </button>
          </div>
        </form>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Registro generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddCajaForm;
